import { Component } from '@verndale/core';
import { v4 as uuidv4 } from 'uuid';

class JumplinksContainer extends Component {
  breakpoint = window.matchMedia('(min-width: 1280px)');
  offsetTop = 0;
  lastScrollTop = 0;

  constructor(el: HTMLElement) {
    super(el);

    this.generateJumplinks();
    this.handleBreakpoint();
    this.addEventListeners();
  }

  setupDefaults() {
    this.dom = {
      jumpLinksContainer: this.el.querySelector<HTMLElement>(
        '.jump-links-menu__list'
      ),
      jumpLinksSections: this.el.querySelectorAll('[data-anchor]')
    };
  }

  addEventListeners() {
    document.addEventListener('scroll', this.handleScroll.bind(this));
    this.breakpoint.addEventListener(
      'change',
      this.handleBreakpoint.bind(this)
    );
    (this.dom.jumpLinksContainer as HTMLElement).addEventListener(
      'click',
      this.handleJumpLinksClick.bind(this)
    );
  }

  handleBreakpoint() {
    this.offsetTop = this.breakpoint.matches ? 160 : 0;
  }

  handleScroll() {
    this.updateActiveJumpLink();
  }

  handleJumpLinksClick(e: Event) {
    e.preventDefault();

    const target = e.target as HTMLAnchorElement;
    const id = target.getAttribute('href');

    if (id) {
      const el = document.getElementById(id.replace('#', ''));

      if (el) {
        //scroll to that element + offset
        const y = el.getBoundingClientRect().top + window.scrollY - 150;

        window.scrollTo({
          top: y,
          behavior: 'smooth'
        });
      }
    }
  }

  handleActionsScrollClick(e: Event) {
    e.preventDefault();

    const target = e.currentTarget as HTMLButtonElement;
    const id = target.dataset.scrollTo;

    if (id) {
      const el = document.getElementById(id.replace('#', ''));

      if (el) {
        //scroll to that element + offset
        const y = el.getBoundingClientRect().top + window.scrollY - 150;

        window.scrollTo({
          top: y,
          behavior: 'smooth'
        });
      }
    }
  }

  generateJumplinks() {
    let jumplinks = '';
    const jumpLinksSections = this.dom
      .jumpLinksSections as NodeListOf<HTMLElement>;

    jumpLinksSections.forEach(section => {
      const title = section.getAttribute('data-anchor');
      const id = uuidv4();
      section.setAttribute('id', id);

      jumplinks += `<li><a href="#${id}">${title}</a></li>`;
    });

    (this.dom.jumpLinksContainer as HTMLElement).innerHTML = jumplinks;
  }

  updateActiveJumpLink() {
    let activeIndex = 0;
    const jumpLinksSections = this.dom
      .jumpLinksSections as NodeListOf<HTMLElement>;

    const jumplinks = (
      this.dom.jumpLinksContainer as HTMLElement
    ).querySelectorAll('a');
    const currentScroll = window.scrollY || document.documentElement.scrollTop;
    const scrollDirection = currentScroll > this.lastScrollTop ? 'down' : 'up';
    this.lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;

    jumpLinksSections.forEach((section, index) => {
      const { y } = section.getBoundingClientRect();
      const verticalBreakpoint = Math.round(window.innerHeight / 2 - 60);
      //(verticalBreakpoint, 'JLBreakpoint');
      //console.log(jumpLinksSections, 'section');

      if (scrollDirection === 'up' && y - this.offsetTop < 0) {
        activeIndex = index;
      } else if (scrollDirection === 'down' && y < verticalBreakpoint) {
        activeIndex = index;
      }
    });

    jumplinks.forEach((link, index) => {
      if (index === activeIndex) {
        link.classList.add('active');
      } else {
        link.classList.remove('active');
      }
      //console.log('links',jumplinks)
    });
  }
}

export default JumplinksContainer;
